var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.422,
    height: 9.406,
    viewBox: "0 0 6.422 9.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#040405;stroke:#040405;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.711 0.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1773.271,413.352l3.06-3.09,3.06,3.09.94-.951-4-4.049-4,4.049Z",
    transform: "translate(413.352 -1772.331) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowRight);
export default __webpack_public_path__ + "static/media/ico-arrow-right.0ea8236dd08f4cff6711b5096e32419e.svg";
export { ForwardRef as ReactComponent };